"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurPhilosophy() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const paragraphs = ["Η πλατφόρμα HotelDeals.gr δημιουργήθηκε με έναν ξεκάθαρο στόχο: να φέρει την επανάσταση στον τρόπο με τον οποίο οι ταξιδιώτες ανακαλύπτουν και κλείνουν τη διαμονή τους στην Ελλάδα. Σε μια αγορά που κατακλύζεται από μεσάζοντες και κρυφές χρεώσεις, εμείς επιλέγουμε τη διαφάνεια και την άμεση επαφή.", "Η φιλοσοφία μας βασίζεται στην πεποίθηση ότι η πολυτέλεια και η ποιότητα δεν πρέπει να συνοδεύονται από περιττά κόστη. Μέσω της τεχνολογικής μας υπεροχής και των στρατηγικών συνεργασιών μας, εξασφαλίζουμε τις πραγματικά χαμηλότερες τιμές της αγοράς, επιτρέποντάς σας να επενδύσετε τα χρήματά σας στην ίδια την εμπειρία του ταξιδιού.", "Δεν είμαστε απλώς μια μηχανή αναζήτησης. Είμαστε ο έμπιστος συνεργάτης σας στην Ελλάδα. Κάθε ξενοδοχείο και κάθε προσφορά που εμφανίζεται στην πλατφόρμα μας έχει επιλεγεί με αυστηρά κριτήρια ποιότητας και αξιοπιστίας. Η ασφάλεια των συναλλαγών σας και η ταχύτητα της κράτησης αποτελούν για εμάς αδιαπραγμάτευτες προτεραιότητες.", "Στην HotelDeals.gr, πιστεύουμε ότι το ταξίδι ξεκινά από τη στιγμή της αναζήτησης. Γι' αυτό σχεδιάσαμε μια εμπειρία χρήστη που είναι γρήγορη, απλή και απόλυτα προσαρμοσμένη στις ανάγκες του σύγχρονου ταξιδιώτη. Χωρίς θόρυβο, χωρίς καθυστερήσεις, μόνο οι καλύτερες συμφωνίες για τις επόμενες αναμνήσεις σας."];
  return <section data-section-id="2461" id="εισαγωγή" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 px-6 md:px-12 lg:px-16">
      <div className="relative mx-auto max-w-[1280px]">
        <div ref={contentRef} className={`max-w-4xl transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="mb-12">
            <h2 className="font-default font-bold uppercase text-primary mb-6" style={{
            fontSize: "0.875rem",
            letterSpacing: "0.2em"
          }}>
              Η Φιλοσοφία μας
            </h2>
            <h1 className="font-default font-bold text-foreground mb-12" style={{
            fontSize: "clamp(2.5rem, 6vw, 4.5rem)",
            lineHeight: 1.1,
            letterSpacing: "-0.04em"
          }}>
              Επαναπροσδιορίζοντας την <br />
              <span className="text-primary">Ταξιδιωτική Εμπειρία.</span>
            </h1>
          </div>

          <div className="space-y-8">
            {paragraphs.map((paragraph, i) => <p key={i} data-index={i} className="font-sans text-foreground/90 leading-relaxed" style={{
            fontSize: "1.125rem"
          }}>
                {paragraph}
              </p>)}
          </div>

          <div className="mt-16 pt-12 border-t border-border/50">
            <div className="flex items-center gap-4">
              <div className="h-12 w-[2px] bg-primary" />
              <div>
                <p className="font-default font-bold text-foreground uppercase tracking-widest text-xs">
                  HotelDeals.gr Team
                </p>
                <p className="text-muted-foreground text-sm mt-1">
                  Direct. Secure. Greek.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}